module.exports = __webpack_public_path__ + "static/media/shopimg.03756d84.svg";